<template>
    <div class="row">
        <div class="col-2">
            <Card :title="translate('labels.event_subscriptions')">
                <div class="card-body">
                    <ul class="nav nav-sidebar">
                        <li class="nav-item">
                            <a class="nav-link" :class="{'active': !selectedSubscription.uuid}" @click="selectSubscription()">{{ translate('labels.new_subscription') }}</a>
                        </li>
                        <li class="nav-item" v-for="subscription in subscriptions">
                            <a class="nav-link" :class="{'active': subscription.uuid === selectedSubscription.uuid}" @click="selectSubscription(subscription)">{{ subscription.name }}</a>
                        </li>
                    </ul>
                </div>
            </Card>
        </div>
        <div class="col-10">
            <Card :title="selectedSubscription.name || translate('labels.new_subscription')">
                <div class="card-body">
                    <FormGroup :label="translate('labels.name')">
                        <Input v-model="selectedSubscription.name"/>
                    </FormGroup>
                    <FormGroup :label="translate('labels.link')">
                        <div class="row" v-for="(url, index) in selectedSubscription.urls">
                            <div class="col-2">
                                <Input
                                    v-model="selectedSubscription.urls[index]"
                                    :disabled="true"
                                />
                            </div>
                            <div class="col-2">
                                <Button size="sm"
                                    @click="removeUrl(index)"
                                    color="light"
                                    class="mt-1"
                                >
                                    <i class="mr-2 icon-subtract"></i>
                                    {{ translate('buttons.delete') }}
                                </Button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-2">
                                <Input v-model="newUrl"/>
                            </div>
                            <div class="col-2">
                                <Button size="sm"
                                    @click="addUrl"
                                    color="primary"
                                    class="mt-1"
                                >
                                    <i class="mr-2 icon-add"></i>
                                    {{ translate('buttons.add') }}
                                </Button>
                            </div>
                        </div>
                    </FormGroup>
                    <FormGroup v-for="eventGroup in eventGroups" :label="translate(`labels.${eventGroup.groupKey.replace('-', '_')}`)">
                        <div class="row">
                            <div class="col-6 col-md-4 col-xl-2" v-for="event in eventGroup.events" style="display: flex;">
                                <CheckBox
                                    :model-value="selectedSubscription.events.includes(event.key)"
                                    @update:model-value="toggleEvent($event, event.key)"
                                />
                                <label class="ml-2">{{ event.label }}</label>
                            </div>
                        </div>
                    </FormGroup>
                </div>
                <div class="card-footer d-flex justify-content-end">
                    <Button size="sm"
                        @click="deleteSubscription"
                        color="light"
                        class="mr-2"
                        :disabled="!selectedSubscription.uuid"
                    >
                        {{ translate('buttons.delete') }}
                    </Button>
                    <Button size="sm"
                        @click="saveSubscription"
                        color="teal"
                    >
                        {{ translate('buttons.save') }}
                    </Button>
                </div>
            </Card>
        </div>
    </div>
</template>
<script>
import Card from '../../../../components/new/CardComponent.vue';
import FormGroup from '../../../../components/new/form/group/FormGroup.vue';
import Input from '../../../../components/new/form/Input.vue';
import Button from '../../../../components/new/button/AppButton.vue';
import CheckBox from '../../../../components/new/form/checkbox/AppCheckbox.vue';

import { httpClient } from '../../../../services/HttpClient';
import MessageNotificator from '../../../../services/MessageNotificator';
import { getSubscriptionEvents } from '../../../enums/SubscriptionEventEnum';

export default {
    name: "IndexSubscriptionsPage",
    components: {
        Card, FormGroup, Input, Button, CheckBox
    },
    data() {
        return {
            subscriptions: [],
            selectedSubscription: this.emptySubscription(),
            newUrl: ''
        }
    },
    computed: {
        eventGroups() {
            let groups = {};

            getSubscriptionEvents().forEach((event) => {
                let groupKey = event.split('_')[0];

                if (!groups[groupKey]) {
                    groups[groupKey] = {
                        groupKey: groupKey,
                        events: []
                    };
                }

                groups[groupKey].events.push({
                    key: event,
                    label: translate(`enum.subscription.event.${event}`)
                });
            });

            return Object.values(groups);
        }
    },
    methods: {
        emptySubscription() {
            return {
                name: '',
                events: [],
                urls: []
            };
        },
        selectSubscription(subscription) {
            this.selectedSubscription = subscription ?? this.emptySubscription();
        },
        addUrl() {
            if (this.newUrl === '') {
                return;
            }

            this.selectedSubscription.urls.push(this.newUrl);
            this.newUrl = '';
        },
        removeUrl(index) {
            this.selectedSubscription.urls.splice(index, 1);
        },
        toggleEvent(checked, event) {
            if (checked) {
                this.selectedSubscription.events.push(event);

                return;
            }

            this.selectedSubscription.events = this.selectedSubscription.events.filter(
                (selectedEvent) => selectedEvent !== event
            );
        },
        async fetchSubscriptions() {
            let response = await httpClient.get('/subscriptions', {limit: 0});

            this.subscriptions = response.data.data;
        },
        createSubscription() {
            httpClient.post('/subscriptions', this.selectedSubscription).then((response) => {
                this.subscriptions.push(response.data.data);
                this.selectedSubscription = response.data.data;

                new MessageNotificator().success(translate('alerts.success'));
            })
        },
        updateSubscription() {
            httpClient.put(`/subscriptions/${this.selectedSubscription.uuid}`, this.selectedSubscription).then(() => {
                this.subscriptions = this.subscriptions.map((subscription) => (
                    subscription.uuid === this.selectedSubscription.uuid
                        ? this.selectedSubscription
                        : subscription
                ));

                new MessageNotificator().success(translate('alerts.success'));
            })
        },
        saveSubscription() {
            if (!this.selectedSubscription.uuid) {
                this.createSubscription();

                return;
            }

            this.updateSubscription();
        },
        deleteSubscription() {
            new MessageNotificator().confirm(translate('alerts.confirm_for_delete', {
                model: translate('labels.subscription')
            }), () => {
                httpClient.delete(`/subscriptions/${this.selectedSubscription.uuid}`).then(() => {
                    this.subscriptions = this.subscriptions.filter(
                        (subscription) => subscription.uuid !== this.selectedSubscription.uuid
                    );

                    this.selectSubscription(this.subscriptions[0]);
                })
            })
        }
    },
    async mounted() {
        await this.fetchSubscriptions();

        this.selectSubscription(this.subscriptions[0]);
    }
}
</script>
<style scoped>
.nav-sidebar .nav-link {
    color: rgba(51, 51, 51, .85);
    cursor: pointer;
}

.nav-sidebar .nav-link.active {
    background-color: #f5f5f5;
    color: #333;
}
</style>
